import { render } from "./Configure.vue?vue&type=template&id=5c6bb725"
import script from "./Configure.vue?vue&type=script&lang=js"
export * from "./Configure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__